(() => {
  function init(root) {
    if (root.dataset.ccInitialized) return;
    root.dataset.ccInitialized = 'true';
    const toggles = [...root.querySelectorAll('[data-cc-review-toggle]')];
    const bottom = root.querySelector('.cc-reviews__bottom');
    const initialCount = 3;
    let expanded = new URLSearchParams(window.location.search).get('show_reviews') === 'all';
    let queued = false;
    let lastPhoto = null;

    function activeCards() {
      const widget = root.querySelector('#vstar-reviews');
      const list = widget?.getAttribute('show-type') === 'shopReviews' ? '.tt-shop-reviews' : '.tt-review-list';
      return [...root.querySelectorAll(`${list} > .grid-review`)];
    }

    function setExpanded(next, fromBottom = false) {
      expanded = next;
      root.classList.toggle('cc-reviews--expanded', expanded);
      toggles.forEach(button => {
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? 'Show fewer reviews' : 'View more';
        button.setAttribute('aria-label', expanded ? 'Show fewer customer reviews' : 'View more customer reviews');
      });
      if (fromBottom && expanded) {
        const cards = activeCards();
        const target = cards[initialCount];
        if (target) {
          target.setAttribute('tabindex', '-1');
          target.focus({preventScroll: true});
          target.scrollIntoView({block: 'nearest'});
        }
      }
    }

    function keyboardControl(node, label) {
      if (node.dataset.ccKeyboard) return;
      node.dataset.ccKeyboard = 'true';
      node.setAttribute('role', 'button');
      node.setAttribute('tabindex', '0');
      if (label) node.setAttribute('aria-label', label);
      node.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          node.click();
        }
      });
    }

    function refresh() {
      queued = false;
      const cards = [...root.querySelectorAll('.tt-review-list > .grid-review, .tt-shop-reviews > .grid-review')];
      if (!cards.length) return;
      const hasMore = activeCards().length > initialCount;
      toggles[0].hidden = !hasMore;
      bottom.hidden = !hasMore;
      root.classList.add('cc-reviews--ready');
      cards.forEach(card => {
        const name = card.querySelector('.author-name')?.textContent.trim() || 'a customer';
        const rating = card.getAttribute('data-rating');
        const stars = card.querySelector('.vstar-star');
        if (stars && /^[1-5]$/.test(rating || '')) {
          stars.setAttribute('role', 'img');
          stars.setAttribute('aria-label', `${rating} out of 5 stars`);
          stars.querySelectorAll('svg').forEach(svg => svg.setAttribute('aria-hidden', 'true'));
        }
        card.querySelectorAll('.resource-item img').forEach(img => {
          if (!img.alt || /^\d+$/.test(img.alt)) img.alt = `Customer photo from ${name}'s review`;
          keyboardControl(img, `Open customer photo from ${name}'s review`);
        });
        card.querySelectorAll('.display-text').forEach(node => keyboardControl(node, `Read the full review by ${name}`));
      });
      root.querySelectorAll('.tt-tab').forEach(tab => {
        keyboardControl(tab);
        tab.setAttribute('aria-pressed', String(tab.classList.contains('active')));
      });
      root.querySelectorAll('.tt-sort-content').forEach(node => keyboardControl(node, 'Sort customer reviews'));
      root.querySelectorAll('.sort-item').forEach(node => keyboardControl(node));
    }

    function queueRefresh() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(refresh);
    }

    toggles.forEach(button => button.addEventListener('click', () => {
      setExpanded(!expanded, Boolean(button.closest('.cc-reviews__bottom')));
    }));
    root.addEventListener('click', event => {
      const photo = event.target.closest('.resource-item img');
      if (photo) lastPhoto = photo;
      if (event.target.closest('.tt-tab, .sort-item, .page-control-item, .page-control-button')) {
        setExpanded(true);
        queueRefresh();
      }
    });
    function closePhotoOnEscape(event) {
      if (event.key !== 'Escape' || !lastPhoto) return;
      const close = document.querySelector('#trustoo-review-detail[data-opened="1"] .close-wrapper');
      if (!close) return;
      event.preventDefault();
      close.click();
      lastPhoto.focus({preventScroll: true});
    }
    document.addEventListener('keydown', closePhotoOnEscape);
    const observer = new MutationObserver(queueRefresh);
    observer.observe(root.querySelector('.cc-reviews__content'), {childList: true, subtree: true, attributes: true, attributeFilter: ['show-type']});
    setExpanded(expanded);
    refresh();
    root.addEventListener('shopify:section:unload', () => {
      observer.disconnect();
      document.removeEventListener('keydown', closePhotoOnEscape);
    }, {once: true});
  }
  document.querySelectorAll('[data-cc-reviews]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-cc-reviews]').forEach(init);
  });
})();

